import { DefaultDatasetSizeLimiter } from "@/services/license/license-limiters/dataset-size-limiters/default-dataset-size-limiter";
import { getUserUniqueStemSplitterDatasetSizeLimit } from "@/actions/db/user-unique-dataset-limits";

export class StemSplitterDatasetSizeLimiter extends DefaultDatasetSizeLimiter {
  async getUniqueLimit(userId: string): Promise<number | null> {
    return await getUserUniqueStemSplitterDatasetSizeLimit(userId);
  }
}
